import { RateLibraryTasks } from "modules/activitySearch/models/RateLibraryTasks";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import {
  TFirestoreTimestamp,
  TQueryDocumentSnapshot,
} from "common/types/FirebaseTypes";

export class RateLibrary {
  /** Nome do banco de composição */
  name: string;
  /** Data de modificação do registro */
  modifiedAt?: TFirestoreTimestamp;
  /** Flag que define se o banco de composição foi ativado para pesquisa na EAP */
  active: boolean;
  /** Lista das composições e insumos do banco filtradas pelo termo da pesquisa */
  tasks: Array<FirebaseDocument<RateLibraryTasks>>;

  constructor(name: string, modifiedAt?: TFirestoreTimestamp) {
    this.name = name;
    this.modifiedAt = modifiedAt;
    this.active = false;
    this.tasks = [];
  }

  public static getDefault(): RateLibrary {
    return new RateLibrary("");
  }
}

export function createRateLibraryModelFromDocument(
  doc: TQueryDocumentSnapshot
) {
  const data = doc.data();
  if (!data) throw new Error("Invalid Document!");

  return new FirebaseDocument<RateLibrary>(
    doc.id,
    new RateLibrary(data.name, data.modifiedAt)
  );
}



// WEBPACK FOOTER //
// ./src/modules/activitySearch/models/RateLibrary.tsx